<div class="navbar-container container-fluid pl-0 pr-0" id="navbar-big">
  <div class="row no-gutters">
    @for (item of items; track item; let i = $index) {
      <a class="col-lg text-center item d-flex flex-column justify-content-center align-items-center" [class.disabled]="item.disabled" [routerLink]=item.link routerLinkActive="active" [id]=item.title
        [class.purpleTheme]="color == 'purple'" *checkPermission="item.permission" [class.yellowMenu]="item.isYellow === true" [ngClass]="item.link.charAt(10) == '/' ? 'isSection' : 'isSubsection'">
        <div [ngClass]="item.disabled ? 'fill-light-grey' : 'fill-grey'" class="icon svg" [inlineSVG]=item.svg> </div>
        <div class="title">{{item.title | translate}}</div>
        <span></span><span></span><span></span><span></span><span></span><span></span>
      </a>
    }
  </div>
</div>